module.exports = __webpack_public_path__ + "static/media/productValues2.c70b77bb.svg";